export enum StatType {
  // 下载
  Download = 'download',
  // 收藏
  Favorite = 'favorite',
  // 分享
  Share = 'share',
  // 播放
  Play = 'play',
  // 点赞
  Upvote = 'upvote',
  // 踩
  Dislike = 'dislike',
}

// 音乐标签
export enum MusicTags {
  // AI 翻唱
  AiCover = 'ai-cover',
}
